document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('load', function () {
    // Handle .section-fv
    document.querySelectorAll('.section-fv').forEach(function (el) {
      el.classList.remove('inactive')
    })

    setTimeout(function () {
      document.querySelectorAll('.section-fv').forEach(function (el) {
        el.classList.add('active-puzzle')
      })
    }, 2000)

    setTimeout(function () {
      document.querySelectorAll('.title-fv').forEach(function (el) {
        el.classList.add('active')
      })
    }, 2500)

    // Handle .puzzle elements
    document.querySelectorAll('.puzzle').forEach(function (puzzle) {
      const video = puzzle.querySelector('video')
      const thumbnail = puzzle.querySelector('.video-thumbnail')

      if (video && thumbnail) {
        video.load()

        video.addEventListener('canplay', function onCanPlay () {
          video.removeEventListener('canplay', onCanPlay)

          setTimeout(function () {
            thumbnail.classList.remove('opacity-1')
            thumbnail.classList.add('opacity-0')

            video.classList.remove('opacity-0')
            video.classList.add('opacity-1')

            video.muted = true
            const playPromise = video.play()
            if (playPromise !== undefined) {
              playPromise
                .then(function () {
                  console.log('Video playback started successfully.')
                })
                .catch(function (error) {
                  console.error('Video playback failed:', error)
                })
            }
          }, 2500)
        })
      }
    })
  })
})

// Add event listener to .video-control if it exists
const videoControl = document.querySelector('.video-control')
if (videoControl) {
  videoControl.addEventListener('click', function () {
    const section = this.closest('.section-fv')
    if (!section) return

    const videos = section.querySelectorAll('video')
    const playIcon = section.querySelector('.button-control .play')
    const pausedIcon = section.querySelector('.button-control .paused')
    let allPaused = true

    videos.forEach(function (video) {
      if (!video.paused) {
        allPaused = false
      }
    })

    if (allPaused) {
      videos.forEach(function (video) {
        video.play()
      })
      if (playIcon) playIcon.style.display = 'none'
      if (pausedIcon) pausedIcon.style.display = 'block'
    } else {
      videos.forEach(function (video) {
        video.pause()
      })
      if (playIcon) playIcon.style.display = 'block'
      if (pausedIcon) pausedIcon.style.display = 'none'
    }
  })
}
